module.exports = __webpack_public_path__ + "media/images/captive_portal/Event-d66d6630deddb86e2bb2f8dce0753ce7.svg";